(function() {
  if (typeof window.Snap === 'undefined' || typeof window.mina === 'undefined') {
    return;
  }

  var dropdown = Snap('nav svg#dropdown');
  var path = Snap.select('#path');
  var $dropdownMenu = $('ul.dropdown-menu');
  var $dropdownToggle = $('button.dropdown-toggle');
  var $dropdown = $('.filter.dropdown');
  var $navGlobal = $('#nav-global');
  var $siteLogo = $('a.site-logo');
  var openBlobPath = 'M554.6,457.9c-49.3,46.2-68.1,56.6-87.6,100.8c-26.3,59.3-137.1,40.8-269.5,10.1l7.7-365.2l386.3-1.2C613.1,368.7,603.8,411.8,554.6,457.9z';
  var closedBlobPath = 'M416,12c-49.3,0-117.5,0-137,0c-26.3,0-27,0-81.5,2l7.7-2l386.3-1.2C592.9,10.8,465.2,12,416,12z';
  var openBlobDuration = 600;
  var closeBlobDuration = 850;
  var blobTopRatio = 202 / 800;
  var blobBottomRatio = 569 / 800;
  var blobVisibleHeightRatio = blobBottomRatio - blobTopRatio;
  var windowSmall = false;
  var resizeFrame;

  if (!dropdown || !path || !$dropdownMenu.length || !$dropdownToggle.length) {
    return;
  }

  function resizeDropdownBlob() {
    var dropdownMenu = $dropdownMenu.outerWidth() > $dropdownToggle.outerWidth() ? $dropdownMenu : $dropdownToggle;
    var shift = $dropdownToggle.find('span.cat:contains("Shop")').length > 0 ? 3 : 2.8;
    var dropdownWidth = dropdownMenu.outerWidth() * shift;
    var dropdownShift = 0 - dropdownWidth / shift;
    var dropdownContentHeight = $dropdownToggle.outerHeight() + parseFloat($dropdownMenu.css('margin-top')) + $dropdownMenu.outerHeight();
    var dropdownHeight = dropdownContentHeight / blobVisibleHeightRatio;
    var dropdownTop = 0 - (dropdownHeight * blobTopRatio);

    windowSmall = $(window).width() < 800;
    if (windowSmall) {
      dropdownWidth = dropdownWidth * 2.4;
      dropdownShift = dropdownShift * 2.4;
    } else {
      dropdownWidth = dropdownWidth * 1.2;
      dropdownShift = dropdownShift * 1.2;
    }

    $('header nav svg#dropdown').css({
      width: dropdownWidth + 'px',
      height: dropdownHeight + 'px',
      top: dropdownTop + 'px',
      left: dropdownShift + 'px'
    });
  }

  function showDropdownBlob() {
    $('nav svg#dropdown').css('visibility', 'visible');
  }

  function hideDropdownBlob() {
    $('nav svg#dropdown').css('visibility', 'hidden');
  }

  function open() {
    showDropdownBlob();
    path.animate({ d: openBlobPath }, openBlobDuration, mina.easeinout);

    if (windowSmall) {
      $navGlobal.addClass('show-mobile');
      $siteLogo.addClass('dropdown');
    }

    $(this).one('click', close);
  }

  function close() {
    path.animate({ d: closedBlobPath }, closeBlobDuration, mina.easeinout, hideDropdownBlob);

    if (windowSmall) {
      $navGlobal.removeClass('show-mobile');
      $siteLogo.removeClass('dropdown');
    }

    $(this).one('click', open);
  }

  resizeDropdownBlob();

  dropdown.attr({
    fill: $dropdownMenu.data('background')
  });

  $dropdownToggle.one('click', open);

  $(window).on('resize.dropdownBlob', function() {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(resizeDropdownBlob);
  });

  $('body').on('click.dropdownBlob', function(e) {
    if (!$('.dropdown').is(e.target) && $dropdown.hasClass('show')) {
      path.animate({ d: closedBlobPath }, closeBlobDuration, mina.easeinout, hideDropdownBlob);

      if (windowSmall) {
        $navGlobal.removeClass('show-mobile');
        $siteLogo.removeClass('dropdown');
      }

      $dropdownToggle.one('click', open);
    }
  });
})();
